import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Router from 'router';
import api from 'api';
import GlobalLoading from 'components/BaseComponents/GlobalLoading';
import Storage from 'utils/Storage';
import * as decorators from 'utils/decorators';
import Tools from 'utils/Tools';
import { ConfigProvider } from 'antd';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';
import 'utils/JsSdk';
import 'utils/Track';

import 'antd/dist/antd.css';
import 'antd-mobile/dist/antd-mobile.css';
import 'assets/css/base.scss';
import store from 'redux/store';



if (!Tools.isMobile()) {
  document.body.style.width = '650px';
  document.body.style.height = '100%';
  document.body.style.position = 'relative';
  document.body.setAttribute('class', 'pc-admin-layout-body');
} else {
  document.body.style.width = '100%';
  document.body.style.height = '100%'
  document.body.setAttribute('class', 'mobile-admin-layout-body');
}

Object.keys(decorators).forEach(key => {
  window[key] = decorators[key];
});
window.$api = api;
window.$utils = {
  Storage,
  GlobalLoading
};
ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={locale}>
      <Router />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);
